import { render } from "./AllTests.vue?vue&type=template&id=499f12e3&scoped=true"
import script from "./AllTests.vue?vue&type=script&lang=js"
export * from "./AllTests.vue?vue&type=script&lang=js"

import "./AllTests.vue?vue&type=style&index=0&id=499f12e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499f12e3"]])

export default __exports__